import { render } from "./user-edit.vue?vue&type=template&id=098a86cb&scoped=true"
import script from "./user-edit.js?vue&type=script&lang=js&external"
export * from "./user-edit.js?vue&type=script&lang=js&external"

import "./user-edit.css?vue&type=style&index=0&id=098a86cb&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098a86cb"]])

export default __exports__